import { v4 } from "uuid";
import { create } from "zustand";

export type SnackbarType = "success" | "error";

interface SnackbarMessage {
	id: string;
	message: string;
	type: SnackbarType;
}

interface SnackbarStore {
	messages: SnackbarMessage[];
	addMessage(props: { message: string; type: SnackbarType }): void;
	removeMessage(id: string): void;
}

export const useSnackbarStore = create<SnackbarStore>((set, get) => ({
	messages: [],
	addMessage: ({ message, type }) => {
		set({ messages: [...get().messages, { id: v4(), message, type }] });
	},
	removeMessage: (id: string) => {
		set({ messages: get().messages.filter((m) => m.id !== id) });
	},
}));
